import { CustomCellRendererProps } from "ag-grid-react";
import { DECIMAL_2, INTEGER } from "presentation/utils/numberUtil";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { ChargeWaiverConstant } from "./ChargeWaiverConstant";

const CHARGE_WAIVER_CONSTANT = ChargeWaiverConstant.Table;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_CHARGE_WAIVER_COL_DEF: any[] = [
    {
        headerName: CHARGE_WAIVER_CONSTANT.SEQ_NO,
        field: 'seqNo',
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        // pinned: "left",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CONTAINER_NO,
        field: 'cntrNo',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.TIER_NO,
        field: 'tierNo',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.WAIVER_REASON,
        field: 'waiverReason',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CHARGE_TYPE,
        field: 'chargeType',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.SUB_CHARGE_TYPE,
        field: 'subChargeType',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.STATUS,
        field: 'status',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.SIZE,
        field: 'size',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.TYPE,
        field: 'type',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CHARGE_ON_COMPANY,
        field: 'chargeOnCompany',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.BILL_TO_COMPANY,
        field: 'billToCompany',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CONSORTIUM_CODE,
        field: 'consortiumCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.VESSEL_CODE,
        field: 'vesselCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.VOYAGE_CODE,
        field: 'voyageCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CUSTOMER_NAME,
        field: 'customerName',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.ETD,
        field: 'etd',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
        dataType: "date"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CONTAINER_TYPE_GROUP,
        field: 'cntrTypeGrp',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 220,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.SERVICE_ORDER_CODE,
        field: 'serviceOrdCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 220,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.TARIFF_TYPE,
        field: 'tariffType',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    }, {
        headerName: CHARGE_WAIVER_CONSTANT.TARIFF_CODE,
        field: 'tariffCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CHARGING_FROM_DATE_TIME,
        field: 'chrfrmDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 260,
        dataType: "dateTime"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CHARGING_TO_DATA_TIME,
        field: 'chgToDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 260,
        dataType: "dateTime"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.TIER_FROM_DATE_TIME,
        field: 'tierFromDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 260,
        dataType: "dateTime"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.TIER_TO_DATE_TIME,
        field: 'tierToDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 260,
        dataType: "dateTime"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CHARGE_QTY,
        field: 'qty',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.UOM,
        field: 'uom',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.OPS_LINE,
        field: 'opsLine',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.TRUCKER_NAME,
        field: 'truckerName',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CNIC_NO,
        field: 'cnicNo',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.VEHICLE_NO,
        field: 'vehicleNo',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.DAMAGE_TYPE,
        field: 'damageType',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.AMOUNT,
        field: 'amount',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.REMARKS,
        field: 'remark',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 200,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.COMMODITY_CODE,
        field: 'commodityCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 220,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.FORWARDER_SHIPPER_CONSIGNEE,
        field: 'forwarderCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 280,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.CUSTOMER_GROUP,
        field: 'customerGroup',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 220,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.EXAM_FLAG,
        field: 'examFlag',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.BAT_NO,
        field: 'batNo',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.PAID_THROUGH_DATE,
        field: 'paidThroughDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 220,
        dataType: "date"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.REMARK1,
        field: 'remark1',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 200,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.REMARK2,
        field: 'remark2',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 200,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.REASON_FOR_RECOMMENDATION,
        field: 'reasonForRecommendation',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 300,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.INITIATED_BY,
        field: 'initiatedBy',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.INITIATED_DATE,
        field: 'initiatedDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
        dataType: "date"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.APPROVED_BY,
        field: 'waiverApprovedBy',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.APPROVED_DATE_TIME,
        field: 'waiverApprovedDatetime',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 200,
        dataType: "dateTime"
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.NO_OF_WAIVED_DAYS,
        field: 'waiverNoOfDays',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 260,
        dataType: INTEGER,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.WAIVE,
        field: 'waiverPercentage',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.WAIVE_TYPE,
        field: 'waiverType',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: CHARGE_WAIVER_CONSTANT.EXCEPTION_MSG,
        field: 'exceptionMsg',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 260,
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}
